import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { TurfTalk } from "@/api/client";

/**
 * Deep-link invite acceptance. Route is protected, so an unauthenticated visit
 * is redirected to /login?next=<this> and resumes here after sign-in.
 */
export default function InviteAcceptPage() {
  const { kind, token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("working");
  const [msg, setMsg] = useState("Accepting your invite…");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; ran.current = true;
    (async () => {
      try {
        let dest = "/";
        if (kind === "room") { const r = await TurfTalk.resolveRoomInvite(token); dest = `/room/${r.room?.id || r.room_id || r.id}`; }
        else if (kind === "tailgate") { await TurfTalk.resolveTailgateInvite(token); dest = "/tailgates"; }
        else if (kind === "live" || kind === "livestream") { await TurfTalk.resolveLiveInvite(token); dest = "/live"; }
        else if (kind === "league") { await TurfTalk.leagueRedeem(token); dest = "/leagues"; }
        else throw new Error("Unknown invite type");
        setStatus("ok"); setMsg("Invite accepted! Redirecting…");
        setTimeout(() => navigate(dest, { replace: true }), 900);
      } catch (e) {
        setStatus("error"); setMsg(e.message || "This invite is invalid or expired.");
      }
    })();
  }, [kind, token, navigate]);

  return (
    <div className="min-h-[60vh] grid place-items-center px-6" data-testid="invite-accept">
      <div className="tt-panel rounded-2xl p-8 text-center max-w-sm w-full tt-rise">
        {status === "working" && <Loader2 className="mx-auto mb-3 text-[#4ea152] animate-spin" size={28} />}
        {status === "ok" && <CheckCircle2 className="mx-auto mb-3 text-[#4ea152]" size={28} />}
        {status === "error" && <XCircle className="mx-auto mb-3 text-[#ff6b60]" size={28} />}
        <p className="text-white" data-testid="invite-status">{msg}</p>
        {status === "error" && <button onClick={() => navigate("/")} className="mt-4 px-4 h-10 rounded-lg bg-[#2F7D32] text-white text-sm">Go home</button>}
      </div>
    </div>
  );
}
